module.exports = __webpack_public_path__ + "static/img/bg-tr.3448b842.webp";